import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { BikeService } from 'src/app/services/bike.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { GearManagementService } from 'src/app/services/gear-management.service';

@Component({
  selector: 'app-workshop-jobcard-update-customer-item',
  templateUrl: './workshop-jobcard-update-customer-item.component.html',
  styleUrls: ['./workshop-jobcard-update-customer-item.component.scss']
})
export class WorkshopJobcardUpdateCustomerItemComponent {

  @Input() jobcard: any;
  @Input() item: any;
  @Input() partnerType: string = 'other';
  @Input() partnerTypeID: number = 99;
  @Input() itemTypes: any[] = [];
  @Output() itemSelected = new EventEmitter<any>();
  @Output() ownerChanged = new EventEmitter<boolean>();

  public updating: boolean = false;
  public refreshedItem: any = null;
  @ViewChild('typeDropdown') typeDropdown: any;

  public showItemDetails: boolean = true;
  public showTransferItems: boolean = false;
  public showServiceHistory: boolean = false;
  public partnerData: any;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private userService: UserService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService,
    private bikeService: BikeService,
    private cdr: ChangeDetectorRef,
    private gearService: GearManagementService
  ) { }

  ngOnInit() {
    console.log(this.jobcard);
    this.getItem(this.item.id);
    this.getBikeTypes();
    this.partnerData = this.helpersService.getPartnerData();
  }

  showSteps(step: string) {
    this.showItemDetails = false;
    this.showServiceHistory = false;
    this.showTransferItems = false;
    switch (step) {
      case 'itemDetails':
        {
          this.showItemDetails = true;
          return;
        }
      case 'transferItems':
        {
          this.showTransferItems = true;
          return;
        }
      case 'serviceHistory':
        {
          this.showServiceHistory = true;
          return;
        }
    }
  }

  getBikeTypes() {
    if ((this.itemTypes && this.itemTypes.length > 0) || this.partnerType !== 'bicycle') {
      return;
    }
    this.gearService.getBikeTypes().subscribe((types) => {
      this.itemTypes = types.map((x) => {
        return { value: x.id, label: this.translate.instant(x.label) };
      });
    });
  }

  ngAfterViewInit() {
    // Ensure dropdown value is set after view initialization
    setTimeout(() => {
      if (this.item.typeID && this.itemTypes.length > 0) {
        const typeExists = this.itemTypes.find(t => t.value === this.item.typeID);
        if (typeExists && this.typeDropdown) {
          this.typeDropdown.writeValue(this.item.typeID);
          this.cdr.detectChanges();
        }
      }
    }, 100);
  }

  isValidItem(): boolean {
    return this.item.manufacturer && this.item.model;
  }

  getItem(itemID) {
    this.bikeService.getBike(itemID).subscribe((item) => {
      this.refreshedItem = item;
    });
  }

  updateItem() {
    if (this.isValidItem()) {

      let updatedItem = {
        ...this.refreshedItem,
        RefNo:
          this.item.manufacturer +
          (this.item.model && this.item.model.length > 0
            ? ' - ' + this.item.model
            : ''),
        SerialNo: this.item.serialNo,
        Manufacturer: this.item.manufacturer,
        Model: this.item.model || '',
        Colour: this.item.colour || '',
        ModelYear: this.item.modelYear || 0,
        BikeSize: this.item.bikeSize || '',
        TypeID: this.item.typeID || 99
      };

      this.bikeService.saveBike(updatedItem).subscribe(
        (response) => {
          console.log(response);


          this.updating = false;
          //this.jobcard.selectedItem = this.item;
          this.activeModal.close({ selectedItem: this.item });
        },
        (err) => {
          this.updating = false;
        });
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.updateItem();
  }

  selectDifferentItem() {
    this.activeModal.close({ action: 'selectDifferentItem' });
  }


  setCompleted(event: any) {
    if (event) {
      this.ownerChanged.emit(true);
      this.activeModal.close({ ownerChanged: true });
      
    }
  }

}
